<template>
  <div class="row">
    <div class="col-12">
      <div class="mapstat" id="mapstat"></div>
    </div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
am4core.useTheme(am4themes_animated);

export default {
  mounted() {
    let map = am4core.create("mapstat", am4maps.MapChart);
    //map.geodata = am4geodata_worldLow;
    map.geodataSource.url =
      "https://gist.githubusercontent.com/Robirodalom/175f2fcfe526748afbb5e6e25dcfda1e/raw/511b2b76eab3051fad23c49cbb815270357b122a/deldunantul.json";
    map.projection = new am4maps.projections.Miller();
    let polygonSeries = new am4maps.MapPolygonSeries();
    polygonSeries.useGeodata = true;
    map.series.push(polygonSeries);
    let polygonTemplate = polygonSeries.mapPolygons.template;
    polygonTemplate.tooltipText = "{NAME}";
    polygonTemplate.fill = am4core.color("#74B266");
    let hs = polygonTemplate.states.create("hover");
    hs.properties.fill = am4core.color("#367B25");
    map.zoomControl = new am4maps.ZoomControl();
  },
};
</script>

<style lang="scss" scoped>
.mapstat {
  width: 100%;
  height: 100vh;
}
</style>